<template>
  <div @scroll="listenForPagination">
    <div class="columns">
      <div class="column is-4">
        <div style="margin: 3px 0" class="is-flex is-justify-content-space-between is-align-items-center">
          <select v-model="officeSize" dir="rtl">
            <option :value="undefined"></option>
            <option v-for="option in office_size_options" :key="option.value" :value="option.value">{{ option.text }}</option>
          </select>
          <label class="ltr">Office Size:</label>
        </div>
        <div class="vertical_space"></div>
        <div style="margin: 3px 0" class="is-flex is-justify-content-space-between is-align-items-center">
          <select v-model="skillsExact" dir="rtl">
            <option :value="undefined"></option>
            <option v-for="option in this.dropdownFeaturedSkills" :key="option.value" :value="option.value">{{ option.text }}</option>
          </select>
          <label class="ltr">Skills Exact:</label>
        </div>
      </div>
      <div class="column is-2"></div>
      <div class="column">
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <SearchCompanies class="ltr" ref="search_companies" @select="onCompanySelected"></SearchCompanies>
          <div class="ltr">
            <label>Company:</label>
          </div>
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <BaseInput class="ltr" placeholder="Search by position title" v-model="search_position_title"></BaseInput>
          <div class="ltr">
            <label>Position:</label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column ltr is-flex is-align-items-center is-justify-content-space-between">
        <div>
          <a @click="rejectAllOffers()" v-if="payload.color_group == 'Purple'" class="button is-danger margin-right" :class="{ 'is-loading': is_rejecting_all_offers }">
            Reject All Offers
          </a>
          <a @click="expiredAfterSentAll" v-if="payload.color_group == 'Green'" class="button is-danger margin-right" :class="{ 'is-loading': isExpiredAfterSentAll }">
            Expired After Sent All
          </a>
          <a @click="disableSearchByCompany" v-if="selected_company" class="button is-danger">בטל חיפוש לפי חברה</a>
        </div>
        <checkbox :checked="isHotPositions" v-model="isHotPositions">Is Hot Positions ?</checkbox>
      </div>
    </div>
    <hr/>
    <div class="vertical_space"></div>
    <div v-if="is_loading_offers" class="is-flex is-align-items-center is-justify-content-center">
      <div class="loading"></div>
    </div>
    <div
      style="border-bottom: 1px solid rgba(0, 0, 0, 0.18); padding-top: 12px; padding-bottom: 12px;"
      :key="offer.id"
      v-for="offer in offers"
    >
      <div class="is-flex is-align-items-center mb-4">
        <div class="is-flex is-align-items-center">
          <p><b>Position:</b></p>
          <link-entity
            class="mx-2"
            :additional_data="{ resource_type: 'Position' }"
            :payload="offer.position"
          ></link-entity>
        </div>
        <div class="is-flex is-align-items-center my-5">
          <p><b>Company:</b></p>
          <link-entity
            class="mx-2"
            :additional_data="{ resource_type: 'Company' }"
            :payload="offer.position.company"
          ></link-entity>
        </div>
      </div>
      <div class="is-flex is-align-items-center">
        <div class="is-flex is-align-items-center">
          <p><b>Name: </b></p>
          <link-entity
            style="margin-right: 6px;"
            :payload="offer.applicant"
          ></link-entity>
        </div>
        <div style="margin-right: 10px;" class="is-flex is-align-items-center">
          <div class="is-flex is-align-items-center" style="margin-right: 10px;">
            <span style="margin-right: 5px;"><b>ID:</b> {{ offer.id }}</span>
            <button
              @click="copyOfferId(offer.id)"
              class="button is-small is-light"
              :class="{ 'is-success': copiedOfferId === offer.id }"
              style="margin-right: 5px;"
              :title="copiedOfferId === offer.id ? 'Copied!' : 'Copy Offer ID'"
            >
              <span class="icon is-small">
                <i :class="copiedOfferId === offer.id ? 'fas fa-check' : 'fas fa-copy'"></i>
              </span>
              <span v-if="copiedOfferId === offer.id">✓</span>
              <span v-else>📋</span>
            </button>
          </div>
          <link-entity
            :additional_data="{ resource_type: 'Offer' }"
            :payload="offer"
          ></link-entity>
          <a @click="sendCv(offer)" style="margin-right: 10px;" class="button is-info">Send CV</a>
          <a @click="vested(offer)" style="margin-right: 10px;" class="button is-info">Vested</a>
          <a @click="rejectOffer(offer)" style="margin-right: 10px;" class="button is-info">X</a>
          <button class="button is-warning is-outlined is-small" style="margin-right: 10px;" @click="aiEvaluate(offer)" title="הערכת AI">AI</button>
          <a @click="openWhatsappTemplatesModal(offer)" style="margin-right: 10px; cursor: pointer;" title="שלח הודעת WhatsApp עם תבניות">
            <img src="/whatsapp.svg" width="30px" height="30px" style="filter: hue-rotate(120deg) saturate(2);">
          </a>
          <WhatsAppLink v-bind="offers_helper.getWhatsAppLinkPayload(offer, 'ghanaFlagMessage')" style="margin-right: 10px;"></WhatsAppLink>
          <button class="button mx-2" @click="sendWhatsapp(offer)">Send Offer WA</button>
          <OfferConversationButton :payload="offer" style="margin-right: 10px;"></OfferConversationButton>
        </div>
      </div>
      <div class="is-flex is-align-items-center">
        <offer-status :payload="offer"></offer-status>
        <div class="horizontal_space"></div>
        <p>עודכן ב- <b>{{ time_helper.makeTimeReadable(offer.updated_at) }}</b></p>
        <div class="horizontal_space"></div>
        <p>, מרחק - <b>{{ offer.distance }}</b></p>
      </div>
      <div>
        <div v-if="payload.color_group == 'Green'" class="is-flex">
          <p dir="ltr">{{ time_helper.makeTimeReadable(offer.sent_at) }} - <b>sent at</b></p>
        </div>
        <div v-if="payload.color_group == 'Purple'" class="is-flex">
          <p dir="ltr">{{ time_helper.makeTimeReadable(offer.established_date) }} - <b>created at</b></p>
        </div>
        <div class="is-flex">
          <b>Offer Message: </b>
          <div class="horizontal_space"></div>
          <message :payload="offer" :additional_data="{ resource_type: 'Offer', endpoint: '/offers/', headers: 'admin_headers' }"></message>
        </div>
        <div v-if="showApplicantMessage" class="is-flex">
          <b>Applicant Message: </b>
          <div class="horizontal_space"></div>
          <message :payload="offer.applicant" :additional_data="{ resource_type: 'Applicant', endpoint: '/users/', headers: 'admin_headers' }"></message>
        </div>
        <div class="is-flex">
          <AttributeDisplay
            :value="offer.applicant.preferred_work_region"
            :data="offer.applicant"
            title="Preferred Work Region"
            requestName="updateApplicant"
            requestValue="preferred_work_region"
          />
        </div>
        <div class="is-flex">
          <AttributeDisplay
            :value="offer.applicant.salary_expectations_comment"
            :data="offer.applicant"
            title="Salary Expectations"
            requestName="updateApplicant"
            requestValue="salary_expectations_comment"
          />
        </div>
        <p><b>Filters Message:</b> {{ offer.filters_message }}</p>
      </div>
    </div>
    <div v-if="is_paginating" class="is-flex is-align-items-center is-justify-content-center">
      <div class="loading" />
    </div>
    <div v-if="is_last_offers" class="text_align_center">
      <p style="padding: 15px;">YOU'RE CAUGHT UP WITH ALL OF THE OFFERS</p>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import AttributeDisplay from '@/components/AttributeDisplay'
import Message from '@/components/Message'
import TimeHelper from '@/custom/classes/time_helper.js'
import OffersHelper from '@/custom/classes/offers_helper.js'
import LinkEntity from '@/components/LinkEntity'
import OfferStatus from '@/components/OfferStatus'
import WhatsAppLink from '@/components/WhatsAppLink'
import SearchCompanies from '@/components/SearchCompanies'
import BaseInput from '@/components/BaseInput'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import Checkbox from '@/components/Checkbox'
import OfferConversationButton from '@/components/OfferConversationButton'

export default {
  name: 'ghana-flag-form',
  components: {
    LinkEntity,
    AttributeDisplay,
    OfferStatus,
    WhatsAppLink,
    Message,
    SearchCompanies,
    BaseInput,
    Checkbox,
    OfferConversationButton
  },
  props: ['payload'],
  data () {
    return {
      time_helper: new TimeHelper(),
      offers_helper: new OffersHelper(),
      questions_helper: new QuestionsHelper(),
      requestController: new AbortController(),
      offers: [],
      office_size_options: [],
      search_position_title: '',
      selected_company: undefined,
      officeSize: undefined,
      skillsExact: undefined,
      isHotPositions: this.payload.isHotPositions ? true : undefined,
      is_loading_offers: true,
      is_paginating: false,
      is_last_offers: false,
      is_rejecting_all_offers: false,
      isExpiredAfterSentAll: false,
      page: 1,
      per: 10,
      copiedOfferId: null
    }
  },
  computed: {
    ...mapGetters('settings', ['showApplicantMessage']),
    ...mapGetters('skills', ['dropdownFeaturedSkills'])
  },
  watch: {
    search_position_title () {
      this.resetOffersBeforeReload()
      this.getOffers()
    },
    officeSize () {
      this.resetOffersBeforeReload()
      this.getOffers()
    },
    skillsExact () {
      this.resetOffersBeforeReload()
      this.getOffers()
    },
    isHotPositions () {
      this.resetOffersBeforeReload()
      this.getOffers()
    }
  },
  created () {
    this.getOffers()
    this.getQuestionsFilters()
  },
  methods: {
    sendCv (data) {
      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    rejectOffer (offer) {
      this.offers_helper.rejectOffer(offer)
    },
    openWhatsappTemplatesModal (offer) {
      this.create({
        designator: 'whatsapp-templates-modal',
        component_name: 'ModalOfferWhatsappTemplates',
        modal_title: 'הצעת משרה למועמד',
        modal_width: 900,
        is_center_modal: true,
        data: offer
      })
    },
    getDefaultRequestData () {
      return {
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id,
        custom_sort: this.getDefaultCustomSort()
      }
    },
    // The Green modal paginates 10 offers per page, and the server slices AFTER sorting,
    // so page 1 has to be globally ordered by pipeline stage - otherwise an offer that just
    // moved to an advanced status stays buried on a later page.
    getDefaultCustomSort () {
      if (this.payload.color_group == 'Green') {
        return 'offer_status_priority'
      }
      return this.payload.resource_type == 'Applicant' ? 'offer_position_hot' : undefined
    },
    getOffers () {
      this.requestController.abort()
      this.requestController = new AbortController()
      let request_data = {
        ...this.getDefaultRequestData(),
        office_size: this.officeSize,
        skills_exact: this.skillsExact,
        is_hot_positions: this.isHotPositions || undefined,
        statuses: this.payload.statuses,
        per: this.per,
        page: this.page
      }
      if (this.selected_company != undefined) {
        request_data.company_id = this.selected_company.resource_id
        request_data.statuses = undefined
      }
      if (this.search_position_title) {
        request_data.position_title = this.search_position_title
        request_data.statuses = undefined
      }

      this.$network_utils.getResourceOffers({ ...request_data, controller: this.requestController }).then(response => {
        this.is_last_offers = response.length == 0
        this.is_paginating = false
        this.is_loading_offers = false
        if (response.length > 0) {
          response = this.sortOffers(response)
        }
        this.offers.push(...response)
        // One lookup per company, only for the offers that just arrived. The old loop
        // re-fetched every already-loaded offer on each pagination, two calls per offer
        // (2026-10-22: ~1,000 is_discrete requests an hour from one open form).
        if (!this._company_details) this._company_details = {}
        response.forEach(async offer => {
          const company_id = offer.position.company.id
          try {
            if (!this._company_details[company_id]) {
              this._company_details[company_id] = Promise.all([
                this.$network_utils.getResourceQuestions({ current_type: 'Company', current_resource_id: company_id, designators: 'is_discrete' }),
                this.$network_utils.getResourceText({ current_type: 'Company', current_resource_id: company_id, designator: 'public_hidden_name' })
              ]).catch(error => {
                delete this._company_details[company_id]
                throw error
              })
            }
            const [is_discrete, public_name] = await this._company_details[company_id]

            // Handle case where questions response might be empty
            if (is_discrete && is_discrete.length > 0) {
              const questionsWithAnswers = this.questions_helper.getQuestionsWithAnswers(is_discrete)
              offer.position.company.is_discrete = questionsWithAnswers.length > 0 && questionsWithAnswers[0].answers.includes('TRUE')
            } else {
              offer.position.company.is_discrete = false
            }

            // Handle case where public_name might be empty (204 response)
            offer.position.company.public_name = public_name && public_name.content ? public_name.content : ''
          } catch (error) {
            console.error('Error fetching company details for offer:', offer.id, error)
            offer.position.company.is_discrete = false
            offer.position.company.public_name = ''
          }
        })
      })
    },
    sendWhatsapp (data) {
      this.create({
        designator: 'whatsapp-conversation-modal',
        component_name: 'ModalWhatsappMessager',
        modal_title: 'Conversation',
        props: {
          applicant: data.applicant,
          offer: data
        }
      })
    },
    sortOffers (offers) {
      if (this.payload.color_group == 'Red') {
        return this.sortOffersByColorGroup(offers, 'Red')
      }
      if (this.payload.color_group == 'Purple') {
        return this.sortOffersByColorGroup(offers, 'Purple')
      }
      if (this.payload.color_group == 'Green') {
        return this.sortOffersByColorGroup(offers, 'Green')
      }
      return offers.sort(this.sortDefault)
    },
    sortDefault (a, b) {
      let a_time = new Date(a.updated_at).getTime()
      let b_time = new Date(b.updated_at).getTime()
      return ((b.position.is_hot - a.position.is_hot) || (b_time - a_time))
    },
    sortOffersByColorGroup (offers, color_group) {
      return offers.sort((a, b) => {
        let is_hot_level = b.position.is_hot - a.position.is_hot
        let offer_order_function = this[`get${color_group}OfferOrder`]
        let status_level = offer_order_function(b.status.name) - offer_order_function(a.status.name)
        // Green is ordered server-side by updated_at then descending id (see getDefaultCustomSort),
        // so the within-page tiebreak has to match it exactly. Red/Purple carry the same latent
        // paging bug and are deliberately left on created_at - out of scope for this fix.
        let date_field = color_group == 'Green' ? 'updated_at' : 'created_at'
        let date_level = new Date(b[date_field]).getTime() - new Date(a[date_field]).getTime()
        let id_level = b.id - a.id
        return is_hot_level || status_level || date_level || id_level
      })
    },
    getRedOfferOrder (status_name) {
      if (status_name == 'admin_rejected') {
        return 1
      }
      if (status_name == 'applicant_rejected') {
        return 2
      }
      if (['company_rejected', 'company_rejected_advanced', 'company_rejected_final'].includes(status_name)) {
        return 3
      }
      if (status_name == 'company_familiar') {
        return 4
      }
      return 0
    },
    getQuestionsFilters () {
      this.$network_utils.getQuestions({ designators: 'office_size', current_resource_id: 1, current_type: 'Applicant' }).then(response => {
        this.office_size_options = response[0].options.map(option => {
          return { text: option.text, value: option.id.toString() }
        })
        this.is_loading = false
      })
    },
    getPurpleOfferOrder (status_name) {
      return status_name == 'awaiting_applicant_strong' ? 1 : 0
    },
    // TWIN: rebase_server/lib/search/main.rb -> Search::Main::OFFER_STATUS_PRIORITY holds the
    // same table. The server orders the whole result set with it before paging; this re-sorts
    // the page we got back, so the two must stay identical. Change one, change the other.
    // Anything unlisted - company_never_replied included - is 0.
    getGreenOfferOrder (status_name) {
      if (status_name == 'done') {
        return 6
      }
      if (status_name == 'vesting') {
        return 5
      }
      if (status_name == 'received_proposal') {
        return 4
      }
      if (status_name == 'interview') {
        return 3
      }
      if (status_name == 'company_process') {
        return 2
      }
      if (status_name == 'awaiting_company_sent') {
        return 1
      }
      return 0
    },
    vested (offer) {
      this.create({ designator: 'vested-confirmation-modal', component_name: 'VestedConfirmationForm', data: offer, modal_title: 'Vested' })
    },
    listenForPagination (event) {
      if (this.is_last_offers) {
        return
      }
      let modal_body = event.target
      let is_on_bottom = modal_body.scrollTop >= (modal_body.scrollHeight - modal_body.offsetHeight)
      if (is_on_bottom && !this.is_paginating) {
        this.is_paginating = true
        this.page += 1
        this.getOffers()
      }
    },
    onCompanySelected (company) {
      this.selected_company = company
      this.resetOffersBeforeReload()
      this.$nextTick(() => {
        this.getOffers()
      })
    },
    disableSearchByCompany () {
      this.search_position_title = ''
      this.selected_company = undefined
      this.$refs.search_companies.clearText()
      this.resetOffersBeforeReload()
      this.getOffers()
    },
    resetOffersBeforeReload () {
      this.is_loading_offers = true
      this.is_paginating = false
      this.offers = []
      this.page = 1
      this.is_last_offers = false
    },
    rejectAllOffers () {
      // Get recruiter name
      let recruiterName = ''
      try {
        const owner = this.$utils.getOwner()
        recruiterName = owner.name
      } catch (e) {
        console.error('Error loading recruiter name:', e)
      }

      // Open modal using standard modal system
      this.create({
        designator: 'reject-all-offers-modal',
        component_name: 'RejectAllOffersModal',
        modal_title: 'דחיית כל ההצעות',
        modal_width: 600,
        is_center_modal: true,
        data: {
          recruiterName: recruiterName,
          onConfirm: this.handleRejectAllConfirm
        }
      })
    },
    async handleRejectAllConfirm (payload) {
      try {
        this.is_rejecting_all_offers = true
        const response = await this.$network_utils.getResourceOffers({
          ...this.getDefaultRequestData(),
          custom_sort: undefined, // bulk action wants the whole set; ordering it just costs time
          statuses: this.payload.statuses
        })

        // Determine new status based on selection
        const newStatus = payload.option === 'not_relevant' ? 'admin_rejected' : 'expired_before_sent'

        // Update all purple offers
        const updatePromises = response.map(offer => {
          return this.$network_utils.updateOffer({
            id: offer.id,
            status: newStatus,
            message: payload.message,
            bulk_rejection: true
          })
        })

        await Promise.all(updatePromises)

        this.$utils.emit('show_toast', { text: `${response.length} הצעות נדחו בהצלחה` })

        // Refresh the offers list
        this.resetOffersBeforeReload()
        this.getOffers()
      } catch (error) {
        console.error('Error rejecting offers:', error)
        this.$utils.emit('show_toast', { text: 'שגיאה בדחיית ההצעות', type: 'error' })
      } finally {
        this.is_rejecting_all_offers = false
      }
    },
    expiredAfterSentAll () {
      this.isExpiredAfterSentAll = true
      // bulk action wants the whole set, not an order
      this.$network_utils.getResourceOffers({ ...this.getDefaultRequestData(), custom_sort: undefined, statuses: 'awaiting_company_sent' }).then(response => {
        response.forEach(offer => {
          this.$network_utils.updateOffer({ id: offer.id, status: 'expired_after_sent', message: 'עודכנו כי המשרה כבר אינה אקטיבית' })
        })
        this.$utils.emit('show_toast', { text: 'כל האופרים נדחו בהצלחה' })
        this.isExpiredAfterSentAll = false
      })
    },
    copyOfferId (offerId) {
      navigator.clipboard.writeText(offerId.toString()).then(() => {
        this.copiedOfferId = offerId
        this.$utils.emit('show_toast', { text: `Offer ID ${offerId} copied to clipboard!`, type: 'success' })
        // Reset the copied state after 2 seconds
        setTimeout(() => {
          this.copiedOfferId = null
        }, 2000)
      }).catch(err => {
        console.error('Failed to copy offer ID: ', err)
        this.$utils.emit('show_toast', { text: 'Failed to copy offer ID', type: 'error' })
      })
    },
    aiEvaluate (offer) {
      this.create({
        designator: 'ai-evaluation-modal-' + offer.id,
        component_name: 'AiEvaluationModal',
        data: offer,
        modal_title: 'הערכת AI',
        modal_width: 700,
        is_center_modal: true
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style scoped>
  .filter_by_company_name_container {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    justify-content: center;
  }
</style>
